<template>
  <!---->
  <div>
    <div class="group-logo-class">
<!--      <img src="../image/logo2.png" class="img-logo-class" @click="toHome()"/>-->
      <div class="group-class">
        <div class="child-group-class">
          <span>
            一级分类：
          </span>
          <div class="child-title-group-class" v-for="(item,index) in oneGroup" :key="index">
            <a @click="getTwoChildGroup(item.child,item.catCode)" @mouseover="getTwoChildGroup(item.child)" class="a-child-title-group-class">{{item.catName}}</a>
            <a class="no-cursor-a-class">|</a>
          </div>
        </div>
        <hr style="border:1px dashed #B0B0B0;height:0px;">
        <div class="child-group-class">
          <span>
            二级分类：
          </span>
          <div class="child-title-group-class" v-for="(item,index) in twoGroup" :key="index">
            <a @click="getThreeChildGroup(item.child,item.catCode)" @mouseover="getThreeChildGroup(item.child)" class="a-child-title-group-class">{{item.catName}}</a>
            <a class="no-cursor-a-class">|</a>
          </div>
        </div>
        <hr style="border:1px dashed #B0B0B0;height:0px">
        <div class="child-group-class">
          <span>
            三级分类：
          </span>
          <div class="child-title-group-class" v-for="(item,index) in threeGroup" :key="index">
            <a @click="getGoodsList(item.catCode)" class="a-child-title-group-class">{{item.catName}}</a>
            <a class="no-cursor-a-class">|</a>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import {billOrders, getClass} from '../../api'
export default {

  name: "LogoGroup.vue",

  data()
  {
    return {
      oneGroup:[],
      twoGroup:[],
      threeGroup:[],
      userInfo:{}
    }
  },
  methods:{
    toHome(){
      this.$router.push("/home");
    },
    getTwoChildGroup(child,val){
      this.twoGroup=child;
      if(typeof(val) == "undefined" || val == null ) {
        this.threeGroup=[];
      }else{
        this.getGoodsList(val);
      }
    },
    getThreeChildGroup(child,val){
      this.threeGroup=child;
      if(typeof(val) == "undefined" || val == null ) {

      }else{
        console.log(val);
        this.getGoodsList(val);
      }
    },
    getClassList(){
      getClass({
      }).then(res=>{
        //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
        // 请求返回数据
        let dataset = res.data.data;
        if(dataset.length==0){
          this.$message.error('获取商品分类列表失败');
          return false;
        }else{
          this.oneGroup = dataset;
          sessionStorage.setItem("CLASSLIST",JSON.stringify(dataset));
        }
      }).catch(err=>{
        // 请求失败执行
        console.log(err)
      })
    },
    getGoodsList(val){
        billOrders({
          M_STAFFID: this.userInfo.STAFFID,
          M_ORGID: this.userInfo.OWNERID,
          M_ENTID: this.userInfo.ENTID,
          M_ACTION: 47,
          M_PAGECOUNT: 100000,
          M_PAGE: 1,
          M_CLASS:val
        }).then(res => {
          console.log(res);
          //这个接口数据是application/x-www-form-urlencoded，所以参数要进行qs转化
          // 请求返回数据
          let dataset = res.data.data.DATASET;
          // console.log("dataset" + dataset);
          if (dataset.length == 0) {
            this.$message.error('获取商品失败，请联系管理员！');
            return false;
          } else {
            //this.options=dataset;
            // this.gridData = dataset;
            this.$emit("getGoodsList",dataset);
            // console.log(dataset[0]);
            // sessionStorage.setItem("USERINFO",dataset[0]);
            // this.$router.push('/home');
          }
        }).catch(err => {
          // 请求失败执行
          // console.log(err)
        })
    }
  },
  mounted()
  {
    this.userInfo = JSON.parse(sessionStorage.getItem("USERINFO"));
    if(typeof(this.userInfo) == "undefined" || this.userInfo == null ){

    }else{
      this.staffName = this.userInfo.STAFFNAME;
    }
    this.getClassList();
  }
}


</script>

<style scoped>
.group-logo-class{
  height: 115px;
  line-height: 115px;
  display: flex;
  background-color: #f2f2f2;
}
.img-logo-class{
  width: 100%;
  height: 110px;
  margin-top: 10px;
  position: relative;
  /*margin-left: 10%;*/
  display: flex;
  width: 80px;
  height: 80px;
  cursor: pointer;
  line-height: 110px;
}
.group-class{
  all:initial;
  margin-top: 10px;
  margin-left: 10%;
  font-size: 15px;
  color: #666666;
  width: 80%;
}
.child-group-class{
  display: flex;
}
.child-group-class>span{
  pointer-events: none;
}
.child-title-group-class{
  padding-left: 4px;
  padding-right: 4px;
}
.a-child-title-group-class{
  cursor:pointer;
}
.a-child-title-group-class:hover{
  color: #d24f48;
  text-decoration: underline;
}
.no-cursor-a-class{
  color: #999;
  padding-left: 1px;
  /*padding-right: 1px;*/
  pointer-events: none;
}
</style>



// WEBPACK FOOTER //
// src/components/component/LogoGroup.vue